import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Hero from './components/Hero';
import Typography from '@mui/material/Typography';
import Advantages from './components/Advantages';
import { Box } from '@mui/system';
import Description from './components/Description';
import Partners from './components/Partners';
import retrieveData from './retrieveData';

const FourthStep = ({
  initialState,
  secondState,
  thirdState,
  handleCurrentStep,
}) => {
  if (initialState) {
    retrieveData[0].email = initialState.fullName;
    retrieveData[0].status = initialState.dateOfBirth;

    retrieveData[1].email = initialState.gender;
    retrieveData[1].status = initialState.class;

    retrieveData[2].email = initialState.nationality;
    retrieveData[2].status = initialState.religion;

    retrieveData[3].email = initialState.motherTongue;
    retrieveData[3].status = initialState.birthPlace;

    retrieveData[4].email = initialState.aadhar;
    retrieveData[4].status = initialState.transport;
  }

  console.log('initialState', initialState);
  return (
    <Box>
      <Box></Box>
      <TableContainer component={Paper}>
        <br />
        <Partners />
        <Table sx={{ minWidth: 700 }} aria-label="">
          <TableHead sx={{ bgcolor: '#377dff' }}>
            <TableRow>
              <TableCell>
                <Typography
                  fontWeight={700}
                  // sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  color={'white'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                  marginLeft={20}
                >
                  Personal Details
                </Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell>
                <Typography
                  variant={'caption'}
                  fontWeight={700}
                  sx={{ textTransform: 'uppercase' }}
                ></Typography>
              </TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {retrieveData.map((item, i) => (
              <TableRow
                key={i}
                sx={{
                  '&:last-child td, &:last-child th': { border: 0 },
                }}
              >
                <TableCell component="th" scope="row">
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.name}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={'subtitle2'}>{item.email}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={'subtitle2'} fontWeight={700}>
                    {item.title}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography variant={'subtitle2'}>{item.status}</Typography>
                </TableCell>
                <TableCell>
                  <Typography color={'text.secondary'} variant={'subtitle2'}>
                    {item.role}
                  </Typography>
                </TableCell>
                <TableCell>
                  <Typography
                    color={'primary'}
                    variant={'subtitle2'}
                    fontWeight={700}
                    sx={{ cursor: 'pointer' }}
                  ></Typography>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <br />
      <Advantages
        secondState={secondState}
        handleCurrentStep={handleCurrentStep}
      />
      <br />
      <Hero secondState={secondState} handleCurrentStep={handleCurrentStep} />
      <br />
      <Description
        initialState={initialState}
        thirdState={thirdState}
        handleCurrentStep={handleCurrentStep}
      />
      <br />
    </Box>
  );
};

export default FourthStep;
